import { createLucideIcon } from './lucideIcon'

export const X = createLucideIcon(
  'X',
  <>
    <path d="M18 6 6 18" />
    <path d="m6 6 12 12" />
  </>
)
